import $ from 'jquery';
import Flickity from 'flickity';
import debounce from 'lodash/debounce';
import { breakpoints } from "../utils";

export default class {
  constructor(el) {
    const self = this;
    self.$el = $(el);
    self.state = null;
    self.resize = debounce(self.resize.bind(self), 250);

    $(window).on("resize", self.resize).trigger("resize");
  }
  resize() {
    const self = this;
    if($(window).width() < breakpoints.tablet && self.state !== "mobile") {
      self.flkty = new Flickity(self.$el.get(0), {
        prevNextButtons: false,
        contain: true,
        setGallerySize: true,
        pageDots: true,
      });
      self.state = "mobile";
    } else if($(window).width() >= breakpoints.tablet && self.state !== "desktop") {
      if(self.flkty){
        self.flkty.destroy()
      }
      self.state = "desktop";
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/Mosaic.js